<template>
    <div style="height: 100vh">
        <!-- ================================Logo Upload Input============= -->
        <div v-if="this.$route.name === 'setupProfileLogoMobile'" @click="goBack" class="backButton">
            <img src="../../assets/LandingPage/backButton.svg" />
            <p>Upload Logo</p>
        </div>
        <hr style="opacity: 0.3" v-if="this.$route.name === 'setupProfileLogoMobile'" />

        <div v-else class="backButton" @click="goBack" >
            <img src="../../assets/LandingPage/backButton.svg" />
            <p>Upload Cover</p>
        </div>
        <hr v-if="this.$route.name === 'setupProfileCoverMobile'" style="opacity: 0.3" />

        <div class="mobileuploadMaindiv">
            <div class="headertextlogo" v-if="this.$route.name === 'setupProfileLogoMobile'">
                <p class="logouploadtext">Upload Company Logo</p>
            </div>
            <div v-else>
                <p class="logouploadtext">Upload Company Cover</p>
            </div>
            <div class="drag-dropmobile secondary-font flex">
                <img class="uploadlogoicon" src="../../assets/FrontPage/uploadimage.svg" alt="" />
                <input
                    type="file"
                    id="upload-logo__cover"
                    style="display: none"
                    accept="image/*"
                    @change="setFileVariable"
                />
                <label for="upload-logo__cover" class="uploadlogo">Browse file and upload</label>
                <p class="subtext">.jpeg and .png files supported. Logo should be in 1:1 ratio and under 25kb</p>
                <div v-if="logo && $route.name === 'setupProfileLogoMobile'" class="uploadedlogo">
                    <img width="200" height="170" style="position: relative" :src="logoURL" alt="" />
                    <v-icon
                        color="white"
                        class="remove-imagemobile pointer"
                        size="17"
                        @click.native="removeSelectedImage('logo')"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div v-if="cover && $route.name === 'setupProfileCoverMobile'" class="uploadedlogo">
                    <img width="200" height="170" style="position: relative" :src="coverURL" alt="" />

                    <v-icon
                        color="white"
                        class="remove-imagemobile pointer"
                        size="17"
                        @click.native="removeSelectedImage('cover')"
                    >
                        mdi-close
                    </v-icon>
                </div>
            </div>
        </div>

        <div>
            <div class="previewmobile">
                <img src="../../../temp/assets/MobilePreview.svg" alt="" />

                <div class="mobile-screen">
                    <div class="cover" v-if="!this.coverURL">                        <img src="https://img.icons8.com/fluency-systems-regular/48/000000/image.png" alt="" class="defaultlogo mr-2" />
</div>

                    <div class="uploaded-cover" v-if="this.coverURL">
                        <img :src="coverURL" alt="" />
                    </div>

                    <div class="logo flex --font" v-if="!this.logoURL">
                        <img src="https://img.icons8.com/fluency-systems-regular/48/000000/image.png" alt="" class="defaultlogo mr-2" />
                    </div> 

                    <div class="logo flex --font" v-if="this.logoURL">
                        <img class="" :src="logoURL" alt="" />
                    </div>

                    <div class="bottom-section flex">
                        <div class="content-section">
                            <h3 class="brandnametext --font">{{ brandDetails.name }}</h3>

                            <small class="descriptiontext secondary-font">
                                {{ brandDetails.description }}
                            </small>
                        </div>
                        <div class="flex">
                            <img src="@/assets/FrontPage/LogoAndCover/globe.svg" alt="" class="mr-2" />
                            <v-icon color="#419045">mdi-share-variant-outline</v-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons-section flex">
            <div class="button-div">
                <button
                    class="nextmobile green-background white--text"
                    @click="uploadLogoOrTimelinePhoto"
                    :disabled="nextButtonDisableState"
                >
                 Continue
                    <v-progress-circular indeterminate size="13" class="mb-1 mx-2" width="2" v-if="loader" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import accessToken from "../../helpers/accessToken";
import API_URL from "../../helpers/apiUrls";
// import uploadLogoOrCovermobile from "./components/upload-logo-cover-onmobile";
export default {
    name: "setupProfileLogoMobile",

    data() {
        return {
            heading: "",
            logo: null,
            cover: null,
            logoURL: null,
            coverURL: null,
            loader: false,
            isDragged: false,
            Preview: null,
            isMobile: false,
            companyDetails: {
                heading: "",
                description: "",
            },
            logoPreview: null,
            coverPreview: null,
            isLogoSelected: false,
            isCoverSelected: false,
            isMobile: false,
        };
    },

    computed: {
        brandDetails() {
            return this.$store.getters["mainStore/GET_USER_DETAILS"].brand;
        },
        user() {
            return this.$store.getters["mainStore/GET_USER_DETAILS"];
        },

        nextButtonDisableState() {
            if (this.$route.name === "setupProfileLogoMobile") {
                if (this.logo) {
                    return false;
                }
                return true;
            } else {
                if (this.cover) return false;
                return true;
            }
        },
    },

    mounted() {
        if (this.$refs.logoOrCoverPhotoRef.logo) this.isLogoSelected = true;

        if (this.$refs.logoOrCoverPhotoRef.cover) this.isCoverSelected = true;

        if (this.$route.params.brandDetails) {
            this.getLogoPreview(this.$route.params.brandDetails.logo_image.original);
        }
        this.checkDevices();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
        dragEnter() {
            this.isDragged = true;
        },
        dragLeave() {
            this.isDragged = false;
        },
        dropImages(event) {
            this.isDragged = false;
            if (event.dataTransfer.files.length > 1) {
                this.showToast("You can only select 1 image here!", "error", 100000);
                return;
            }
            if (this.$route.name === "setupProfileLogoMobile") {
                this.logo = event.dataTransfer.files[0];
                this.logoURL = URL.createObjectURL(event.dataTransfer.files[0]);
                this.$emit("logoURL", this.logoURL);
            } else {
                this.cover = event.dataTransfer.files[0];
                this.coverURL = URL.createObjectURL(event.dataTransfer.files[0]);
                this.$emit("coverURL", this.coverURL);
            }
        },

        removeSelectedImage(ImageType) {
            if (ImageType === "logo") {
                this.logo = null;
                this.logoURL = null;
            } else {
                this.cover = null;
                this.coverURL = null;
            }
        },

        setFileVariable(event) {
            if (this.$route.name === "setupProfileLogoMobile") {
                this.logo = event.target.files[0];
                // this.fileName = file.name;
                this.logoURL = URL.createObjectURL(event.target.files[0]);
                this.$emit("logoURL", this.logoURL);
                console.log("Uploaded logo name:", this.logo.name);
            } else if (this.$route.name === "setupProfileCoverMobile") {
                this.cover = event.target.files[0];
                this.coverURL = URL.createObjectURL(event.target.files[0]);
                this.$emit("coverURL", this.coverURL);
                console.log("Uploaded cover name:", this.cover.name);
            }
        },

        uploadLogoOrTimelinePhoto() {
            this.loader = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    if (this.$route.name === "setupProfileLogoMobile") {
                        this.$router.push({ name: "setupProfileCoverMobile" });
                        this.heading = "Cover Image";
                    } else {
                        // SET ACCESS TOKEN HERE
                        accessToken.setCredentials(
                            this.$store.state.mainStore.temporaryAccessToken,
                            this.$store.state.mainStore.temporaryRefreshToken,
                            this.user.brand.brandID,
                            this.user.name,
                            this.user.avatar
                        );
                        this.$router.replace({ name: "MainDashboard" });
                        this.showToast("You have successfully logged in!");
                    }
                    this.loader = false;
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                this.loader = false;
            };

            const formData = new FormData();

            if (this.$route.name === "setupProfileLogoMobile") formData.append("logo_image", this.logo);
            else formData.append("time_line_image", this.cover);

            const headers = {
                Authorization: `Bearer ${this.$store.state.mainStore.temporaryAccessToken}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            this.requestPATCH(
                `${API_URL.brand}/${this.user.brand.brandID}/_partial_update`,
                formData,
                headers,
                successHandler,
                errorHandler
            );
        },

        checkRouteAndRedirect() {
            if (this.$route.name === "setupProfileLogoMobile") this.$router.push({ name: "setupProfileDetails" });
            else {
                this.$router.push({ name: "setupProfileLogoMobile" });
                this.heading = "Logo";
            }
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
        getLogoPreview(URL) {
            console.log("I am fired");
            this.isLogoSelected = true;
            this.logoPreview = URL;
        },

        getCoverPreview(URL) {
            console.log("I am fired cover");

            this.isCoverSelected = true;
            this.coverPreview = URL;
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
    },

    components: {
        // "upload-logo-or-covermobile": uploadLogoOrCovermobile,
    },

    mounted() {
        this.checkDevices();
    },
    watch: {
        logo: function (value) {
            if (!value) this.$emit("removeLogo");
        },

        cover: function (value) {
            if (!value) this.$emit("removeCover");
        },
    },

    created() {
        if (this.$route.name === "setupProfileLogoMobile") this.heading = "Logo";
        else this.heading = "Cover Image";

        this.$emit("setLogoAndCoverLayout");
    },
};
</script>

<style lang="scss" scoped>
.set-up-page {
    height: 100vh;
}

.backButton {
    display: flex;
    margin-right: auto;
    padding-left: 20px;
    height: 64px;
    align-items: center;
    width: 100%;
 
    box-shadow: 1px 0px #000007;
    p {
        margin: 0px;
        margin-left: 13px;
        font-size: 18px;
        font-weight: 500;
    }
    @media all and (min-width: 1025px) {
        display: none;
    }
}
.preview {
    width: 35%;
    margin-right: 80px;
    position: relative;
    border-radius: 30px;
}
.previewmobile {
    width: 80%;
    margin: 0px auto;
    position: relative;
    border-radius: 30px;
    // position: absolute;
}
.previewmobile img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.preview img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mobile-screen {
    width: 91%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position: absolute;
    top: 0;
    border-radius: 30px;
    padding-top: 10px;
}

.defaultlogo{
    height: 20px !important;
    width: 20px !important;
}
.cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 200px;
    width: 100%;
    background-color: #aeb7ae;

    img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
}

.uploaded-cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 200px;
    width: 100%;
    position: relative;
    z-index: 0;
}
.content-section{
    width: 80%;
}
.logo {
    width: 100px;
    height: 100px;
    background-color: #c4c4c4;
    border-radius: 50%;
    transform: translate(10px, -50px);

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

.bottom-section {
    padding: 0 15px;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateY(-30px);
}

.buttons div {
    width: 31.33%;
}

.buttons {
    width: 95%;
    margin: auto;
    justify-content: space-between;
    padding-right: 9px;
}

.buttons button {
    width: 38%;
    background: red;
    font-weight: 500;
    padding: 10px 0;
    font-size: 0.85rem;
    border-radius: 3px;
}
.descriptiontext {
    display: -webkit-box;
    max-width: 800px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.brandnametext {
    width: 80%;
    white-space: nowrap;
    overflow: hidden;

    text-overflow: ellipsis;
}

.upload-section {
    width: 30%;
}
.upload-sectionmobile {
    width: 100%;
}

@media all and (min-width: 1400px) {
    .preview {
        width: 30%;
    }

    .upload-section {
        width: 20%;
    }
}
.upload-button {
    background: rgba(87, 215, 192, 0.05);
    border-radius: 5px;
    padding: 15px 5px;
    margin-top: 20px;
    font-size: 0.95rem;
}
// .backButton {
//     display: flex;
//     margin-right: auto;
//     padding-left: 20px;
//     height: 64px;
//     align-items: center;
//     width: 100%;
//     box-shadow: 1px 0px #000007;
//     p {
//         margin: 0px;
//         margin-left: 13px;
//         font-size: 18px;
//         font-weight: 500;
//     }
//     @media all and (min-width: 1025px) {
//         display: none;
//     }
// }
.uploadedlogo {
    position: absolute;
}

.mobileuploadMaindiv {
    width: 90%;
    margin: 0px auto;
    margin-bottom: 20px;
    margin-top: 20px;
}
.headertextlogo {
    margin-top: 28px;
}
.logouploadtext {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */

    color: #474747;
}
.drag-drop {
    background: #fbfdfc;
    border: 1px dashed #dbdbdb;
    color: #b8c4b9;
    box-sizing: border-box;
    border-radius: 7px;
    flex-direction: column;
    padding: 50px 0;
    margin: 20px 0 30px 0;
    position: relative;

    p {
        margin: 0;
    }
}
.nextmobile {
    width: 100%;
}
.drag-dropmobile {
    flex-direction: column;
    background: rgba(87, 215, 192, 0.05);
    border: 1px dashed rgba(51, 145, 55, 0.75);
    border-radius: 5px;
}
.removeuploadlogoicon {
    display: flex;
    justify-content: center;
    width: 10%;
    align-items: center;
}
.uploadlogo {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */

    margin-bottom: 20px;

    color: #158c52;
}
.previewmobile {
    width: 80%;
    margin: 0px auto;
    position: relative;
    border-radius: 30px;
}
.previewmobile img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.mobile-screen {
    width: 91%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position: absolute;
    top: 0;
    border-radius: 30px;
    padding-top: 10px;
}
.logo {
    width: 100px;
    height: 100px;
    background-color: #edf8ed;
    border-radius: 50%;
    transform: translate(10px, -50px);
    border: 1px solid #e2ece2;
    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

.bottom-section {
    padding: 0 15px;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateY(-30px);
}

.buttons div {
    width: 31.33%;
}

.buttons {
    width: 95%;
    margin: auto;
    justify-content: space-between;
    padding-right: 9px;
}
.cover {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    height: 200px;
    width: 100%;
    justify-content: center;
    display: flex;
    /* text-align: center; */
    align-items: center;
    background-color: #edf8ed;

    img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
}

.uploaded-cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 200px;
    width: 100%;
    position: relative;
    z-index: 0;
}
.uploadlogoicon {
    margin-top: 20px;
    margin-bottom: 20px;
}
.subtext {
    width: 80%;
    margin: 0px auto;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    /* or 18px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Light Grey */

    color: #797e79;

    opacity: 0.75;
    margin-bottom: 20px;
}
.drag-drop > div {
    width: 100px;
    height: 100px;
    position: absolute;
    border: 1px solid #e3e3e3;
    box-sizing: border-box;
    border-radius: 3px;
    top: 50%;
    transform: translateY(-50%);
}

.remove-image {
    background: rgba(125, 125, 125, 0.47);
    border-radius: 50%;
    position: absolute;
    right: 4px;
    top: 3px;
}
.removelogomobile {
    display: flex;
    width: 100%;
    background: #f7fdfc;
    justify-content: space-between;
    height: 56px;
}
.remove-imagemobile {
    background: rgba(125, 125, 125, 0.47);
    border-radius: 50%;
    position: absolute;
    // width: 10%;
}
.removeicondiv {
    display: flex;
}
.removelogotextandicon {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    color: #3a3f3a;
}
.removelogoname {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
    width: 80%;
    margin-top: 13px;
}

.drag-drop img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.buttons-section {
    justify-content: space-between;
    bottom: 0;
    position: sticky;
    width: 100%;
    height: 143px;
    top: 100%;

    z-index: 1;
    // background: red;
}
.button-div {
    width: 90%;
    margin: 0px auto;
    z-index: 1;
    position: sticky;
}

button {
    width: 49%;
    padding: 15px;
    border-radius: 3px;
}

button:disabled {
    // opacity: 0.5;
    background: grey;
}

.previous {
    background: rgba(44, 171, 109, 0.11);
}
</style>
